<template>
	<div class="bg-white px-4 sm:px-5 pb-5 pt-4 rounded-xl shadow-lg mb-[20px]">
		<div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-[10px]">
			<div v-if="fullWidthTitle" class="col-span-2">
				<p v-if="title" class="text-normal font-medium text-gray-800">{{title}}</p>
				<p v-if="subText" class="text-xs font-medium text-gray-800"> {{subText}}</p>
			</div>
			<div v-else class="col-span-1">
				<p v-if="title" class="text-normal font-medium text-gray-800">{{title}}</p>
				<p v-if="subText" class="text-xs font-medium text-gray-800"> {{subText}}</p>
			</div>
			<div class="col-span-1 w-full grid grid-cols-1 xs:grid-cols-2 gap-y-1 gap-x-2 pb-1 sm:pb-0 sm:flex  sm:justify-end sm:items-center">
				<slot name="buttons"></slot>
			</div>
		</div>
		<slot name="content"></slot>
	</div>
</template>

<script>


export default {
	name:"WhiteBox",
	components:{

	},
	props:{
		title:{
			type:String
		},
		subText:{
			type:String
		},
		fullWidthTitle:{
			type:Boolean
		}
	},
	data(){
		return{

		}
	},
	mounted(){

	}

}
</script>

<style>

</style>